import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfmexico() {
  return (
    <>
    <Helmet>
        <title>GMF Mexico | Gandhi Mandela Foundation</title>
        <meta name="description" content="GMF Mexico" />
        <link rel="canonical" href="/gmfmexico" />
    </Helmet>
            <Header/>
                <section className="page-header">
                    <div className="container">
                    <div className="breadcrumb">
                        <a href="/">Home</a>
                        <span>/</span>
                        <span>GMF Mexico</span>
                    </div>
                    <h1>GMF Mexico</h1>
                    </div>
                </section>
                <section className="jury-members">
                <div className="container">
                    <div className="members-grid">
                        <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/DR.-MANUEL-GRANADOS-COVARRUBIAS.jpg" alt="SDr. Manuel Granados Covarrubias" />
                        </div>
                        <h3>Dr. Manuel Granados Covarrubias</h3>
                        <span>(President of GMF Mexico)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Ms.-Altagracia-Gomez-Sierra.jpg" alt="Ms. Altagracia Gómez Sierra" />
                        </div>
                        <h3>Ms. Altagracia Gómez Sierra</h3>
                        <span>(Mexican lawyer, businesswoman, and political advisor)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Ms.-Rosario-Marin.jpg" alt="Ms. Rosario Marín" />
                        </div>
                        <h3>Ms. Rosario Marín</h3>
                        <span>(Mexican-American public servant)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Ms.-Michelle-Ferrari.jpg" alt="Ms. Michelle Ferrari" />
                        </div>
                        <h3>Ms. Michelle Ferrari</h3>
                        <span>(President of the Women Economic Forum Iberoamérica and the CEO & Founder of Great Culture to Innovate, Healthy Place to Work, and Human Richness México)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Blanca-Estela-Perez-Villalobos.jpg" alt="Blanca Estela Pérez Villalobos" />
                        </div>
                        <h3>Blanca Estela Pérez Villalobos</h3>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Mr.-Larry-Rubin.jpg" alt="Mr. Larry Rubin" />
                        </div>
                        <h3>Mr. Larry Rubin</h3>
                        <span>(President of The American Society of Mexico, the American community in Mexico)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Dr.-H.C-Patricia-Gonzalez.jpg" alt="Dr. H.C. Patricia Gonzalez" />
                        </div>
                        <h3>Dr. H.C. Patricia Gonzalez</h3>
                        <span>(Vice President, The American Society of Mexico)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                            <img src="img/members/Ms.-Josefa-Gonzalez-Blanco-Ortiz-Mena.jpg" alt="Ms. Josefa Gonzalez Blanco Ortiz-Mena" />
                        </div>
                        <h3>Ms. Josefa Gonzalez Blanco Ortiz-Mena</h3>
                        <span>(Mexico’s Ambassador to the United Kingdom)</span>
                    </div>
                    
                </div>
                </div>
            </section>
                {/* =========================
                FOOTER
                ========================== */}
            <Footer/>
            </>
  )
}
